<template>
  <div
    class="flex w-full md:bg-[#F9FBFF]"
    :style="{ 'min-height': 'var(--layout-page-content-min-height)' }"
  >
    <slot />
  </div>
</template>
